<!-- https://8es9hr.axshare.com/#g=1&p=%E6%97%A5%E7%B5%90%E4%BD%9C%E6%A5%AD_%E6%9C%83%E8%A8%88 -->
<!-- 日結作業_會計 -->
<template>
    <div style="display: flex">
        <Step :workflow="workflow"></Step>
        <div class="bgf step-form">
            <div class="col-block">
                <div class="block-header has-border">
                    <h3>
                        <strong>{{ $transferDate(settleDate) }} 結帳作業</strong>
                    </h3>
                </div>
                <!-- 會計 -->
                <div class="block-content">
                    <p
                        class="sub_title"
                    >今日開立收款單數量 : {{recordToEdit.voucherStatistic.cashVoucherCount}}</p>
                    <router-link
                        :to="{ name: 'coop_receipt', query: { settleDate: settleDate }}"
                        target="_blank"
                    >
                        <el-button type="primary" plain>收款單管理</el-button>
                    </router-link>
                    <p
                        class="sub_title"
                    >支出轉帳傳票數量 : {{recordToEdit.voucherStatistic.transferVoucherCount}}</p>
                    <router-link
                        :to="{ name: 'expense_summons', query: { settleDate: settleDate }}"
                        target="_blank"
                    >
                        <el-button type="primary" plain>支出轉帳傳票管理</el-button>
                    </router-link>
                    <p
                        class="sub_title"
                    >庫存現金餘額 : {{$addcomma(recordToEdit.dailySettlement.cashOnHand)}}</p>
                    現金 傳票結餘 : {{$addcomma(recordToEdit.cashOnHandBalance)}}
                    <div v-for="item in recordToEdit.bankList">
                        <p class="sub_title" v-if="item.ddAccountTitleId">
                            {{item.bankName}} 活存餘額
                            {{$addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].keyInBalance)}}
                        </p>
                        <p v-if="item.ddAccountTitleId">
                            {{item.bankName}} 活存傳票結餘
                            {{$addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].balance)}}
                        </p>
                    </div>
                    <el-button
                        type="primary"
                        plain
                        @click="SettlementClose('dailySettlementAccountant')"
                    >確認結帳</el-button>
                    <el-button type="danger" plain @click="SettlementMgr('cancel')">中止結帳作業</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Step from "@/components/Step.vue";
import { API } from "@/assets/config";

export default {
    name: "daily",
    components: { Step },
    data() {
        return {
            recordToEdit: {
                bankStatistic: {},
                statistic: {},
                creatorList: {},
                voucherStatistic: {},
                cashOnHand: ""
            },
            workflow: [],
            // 傳票日期
            settleDate: ""
        };
    },
    created() {
        // 會計
        this.getAccountant();
    },

    methods: {
        SettlementMgr(action) {
            var url = API.dailySettlementMgr + `?action=${action}`;
            const form = new FormData();

            let thenCB = json => {
                this.showAjaxSuccessMsg();
            };
            this.mAxiosPost(url, form, thenCB);
        },

        getAccountant() {
            // 取得當日會計關帳資訊
            const url = API.dailySettlementAccountant;
            const thenCB = json => {
                if (json.resultData.status == 1) {
                    // 代表未關帳
                    this.$router.push({
                        name: "daily"
                    });
                }
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData
                );
                this.workflow = json.resultData.workflow.filter(item => {
                    // 傳票確認 沒有 status 剛好拿來過濾
                    return item.status >= 0;
                });
                // 傳票日期
                this.settleDate = json.resultData.dailySettlement.settleDate.split(
                    " "
                )[0];
            };
            const thenCatch = error => {
                const errorCode = (error && error.response && error.response.data)
                    ? error.response.data.ErrorCode
                    : null;
                // 當 errorMessage 顯示 系統資料錯誤 就導回 daily
                if (errorCode === "ES0013") {
                    this.$router.push({
                        name: "daily"
                    });
                } else {
                    this.getErrorHandler(error);
                }
            };
            this.mAxiosGet(url, thenCB, {}, false, thenCatch);
        },
        SettlementClose(api) {
            try {
                this.checkAmount();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }

            var url = API[api];
            const form = new FormData();

            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.getAccountant();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        checkAmount() {
            if (
                this.recordToEdit.dailySettlement.cashOnHand !==
                this.recordToEdit.cashOnHandBalance
            ) {
                throw new Error("現金餘額不一致");
            }
            this.recordToEdit.bankList.forEach(item => {
                if (
                    this.recordToEdit.bankStatistic[item.ddAccountTitleId]
                        .keyInBalance !==
                    this.recordToEdit.bankStatistic[item.ddAccountTitleId]
                        .balance
                ) {
                    throw new Error(`${item.bankName} 活存餘額不一致`);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.block-content {
    line-height: 34px;

    p {
        margin-bottom: 4px;
    }

    .sub_title {
        margin-bottom: 0px;
        font-weight: bold;
    }

    table {
        width: 200px;
        display: inline-table;
        margin-right: 10px;

        td {
            padding: 4px 10px;
            text-align: center;
        }
    }

    .box-card {
        margin-top: 10px;
    }
}

.step {
    cursor: pointer;
}
</style>